import { styled } from '@mui/system';

const BasicCardContainer = styled('div')(({ backgroundColor }: { backgroundColor?: string }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: 212,
    height: 168,
    flexShrink: 0,
    backgroundColor: backgroundColor,
    padding: 24,
    gap: 9,
    '@media (max-width: 1024px)': {
        maxWidth: 142,
        height: 'auto',
        minHeight: 140,
        padding: 14,
        gap: 8,
    }
}));

const BasicCardIcon = styled('img')({
    width: 48,
    height: 48,
    flexShrink: 0,
    '@media (max-width: 1024px)': {
        width: 40,
        height: 40,
    }
});

const BasicCardTitle = styled('h3')(({ color }: { color?: string }) => ({
    color: color,
    fontSize: 20,
    fontWeight: 700,
    lineHeight: '26px',
    '@media (max-width: 1024px)': {
        fontSize: 15,
        lineHeight: '20px',
    }
}));

interface BasicCardProps {
    title: string;
    icon?: string;
    color?: string;
    backgroundColor?: string;
}

export const BasicCard = ({ icon, title, color = '#F1F7F7', backgroundColor = '#002322' }: BasicCardProps) => {
    return (
        <BasicCardContainer backgroundColor={backgroundColor}>
            {icon && <BasicCardIcon src={icon} />}
            <BasicCardTitle color={color}>{title}</BasicCardTitle>
        </BasicCardContainer>
    );
};
